import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import React, { useCallback, useMemo, useState } from 'react';
import useTransitionState from '../../hooks/use-transition-state';
import { context } from './utils';
import Content from './content';
import Icon from './icon';
import Control from './control';
import SimpleControl from './simple.control';
var closingTimeout = 240;
export var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
    onToggle = _ref.onToggle,
    dataTest = _ref.dataTest;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    control = _useState4[0],
    registerControl = _useState4[1];
  var _useState5 = useState({
      current: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    content = _useState6[0],
    registerContent = _useState6[1];
  var _useTransitionState = useTransitionState(opened, {
      duration: closingTimeout
    }),
    _useTransitionState2 = _slicedToArray(_useTransitionState, 2),
    state = _useTransitionState2[0],
    close = _useTransitionState2[1];
  var toggle = useCallback(function (update) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var directCommand, nextState;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            directCommand = typeof update === 'boolean';
            nextState = directCommand ? update : !opened;
            if (!(!directCommand && opened && state === 'show')) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return close();
          case 5:
            onToggle === null || onToggle === void 0 ? void 0 : onToggle(nextState);
            setOpened(nextState);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [opened, close, state, onToggle]);
  var contextValue = useMemo(function () {
    return {
      opened: opened,
      state: state,
      toggle: toggle,
      control: control,
      content: content,
      registerContent: registerContent,
      registerControl: registerControl,
      dataTest: dataTest
    };
  }, [opened, state, toggle, control, content, registerContent, registerControl, dataTest]);
  return React.createElement(context.Provider, {
    value: contextValue
  }, children);
};
Dropdown.Content = Content;
Dropdown.Control = Control;
Dropdown.SimpleControl = SimpleControl;
Dropdown.Icon = Icon;